import { ApplicationConfig } from '@angular/core';

import { provideRouter } from '@angular/router';
import { routes } from './app.routes';

import { provideStore } from '@ngrx/store';
import { userReducer } from './store/user/user.reducer';
import { equipmentReducer } from './store/equipment/equipment.reducer';
import { chatReducer } from './store/chat/chat.reducer';

import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { provideHttpClient } from '@angular/common/http';
import { appLauncherReducer } from './store/appLauncher/appLauncher.reducer';
import { provideMarkdown } from 'ngx-markdown';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideClientHydration(),
    provideAnimationsAsync(),
    provideStore({ user: userReducer, equipment: equipmentReducer, chat: chatReducer, appLauncher: appLauncherReducer}),
    provideStoreDevtools({ maxAge: 25 }),
    provideHttpClient(),
    provideMarkdown()
  ]
};
